import React from 'react';
import { useTranslation } from '../App';

const Journey = () => {
  const t = useTranslation();
  const timeline = [
    { date: 'June 2004', title: 'Where It All Began', desc: 'Karan Sethi begins his journey by starting a furniture import business.' },
    { date: '2004 - 2011', title: 'Retail Expansion', desc: 'Successfully opens multiple furniture stores across Delhi, building a strong retail presence.' },
    { date: '2011', title: 'Interior Design Transition', desc: 'Transitions into interior design services.' },
    { date: '2015', title: 'First Design Office', desc: 'Opens the first dedicated design office.' },
    { date: '2016', title: 'Full Interior Focus', desc: 'Fully dedicates to interior design services.' },
    { date: '2022', title: 'Team Expansion', desc: 'Expands the team significantly.' },
    { date: '2025', title: 'Modern Office', desc: 'Moves into a large, modern office space.' }
  ];

  return (
    <section className="journey">
      <div className="flex jour-flex">
        <div className="founder-cont">
          <span>{t.journey.title}</span>
          <h3>{t.journey.heading}</h3>
          <p>{t.journey.description}</p>
        </div>
        <div className="founder-img">
          <img src="/assets/owner.jpeg" alt="Founder" />
        </div>
      </div>

      <div className="page-wrapper">
        <div className="section-timeline">
          <div className="container">
            <div className="timeline_component">
              <div className="timeline_progress">
                <div className="timeline_progress-bar"></div>
              </div>
              {timeline.map((item, index) => (
                <div key={index} className="timeline_item">
                  <div className="timeline_left">
                    <div className="timeline_date-text">{item.date}</div>
                  </div>
                  <div className="timeline_centre">
                    <div className="timeline_circle"></div>
                  </div>
                  <div className="timeline_right">
                    <div className="margin-bottom-medium">
                      <div className="timeline_text">
                        <h3>{item.title}</h3>
                      </div>
                    </div>
                    <div className="margin-bottom-xlarge">
                      <p className="text-colour-lightgrey">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;